import React, { useEffect, useState, useMemo, useRef } from "react";
import { formatNumberWithCommas } from '../../../common/utility'
import moment from 'moment';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    InputGroup
} from "reactstrap";
import Flatpickr from "react-flatpickr";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import TableContainerV1 from "components/Common/TableContainerV1";
import { getActualSaleVsTarget } from "../../../helpers/UAM/report.helper"
import * as XLSX from 'xlsx';
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import 'flatpickr/dist/plugins/monthSelect/style.css';

const TargetVsActual = () => {

    //meta title
    document.title = "Target Vs Actual Sale | DMS";

    const [targetData, setTargetData] = useState([])

    const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [columnId, setColumnId] = useState("id");
    const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
    const [filters, setFilters] = useState(null);
    const [sortingOptions, setSortingOptions] = useState({
        column: "",
        isAsc: false,
        optionalColumn: ['performance'],
    });
    const flatpickrRef = useRef(null);

    const user = JSON.parse(localStorage.getItem("user"));

    const columns = useMemo(
        () => [
            {
                Header: 'Target',
                accessor: 'targetSaleInLac',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? formatNumberWithCommas(cellProps.value) : "";
                }
            },
            {
                Header: 'Actual Sale',
                accessor: 'actualSaleInLac',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? formatNumberWithCommas(cellProps.value) : "";
                }
            },

            {
                Header: 'Difference',
                accessor: 'difference',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? formatNumberWithCommas(cellProps.value) : "0";
                }
            },
            {
                Header: 'Month',
                accessor: 'month',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? formatDate(cellProps.value) : "";
                }
            },
            {
                Header: 'Performance ',
                accessor: 'performance',
                filterable: true,
                Cell: (cellProps) => {
                    let value = cellProps.row.original.difference
                    if (value === null || value === undefined) {
                        return "";
                    }
                    const iconClass = value < 0 ? 'bx bxs-downvote' : 'bx bxs-upvote';
                    const color = value < 0 ? 'red' : 'green';
                    return (
                        <span style={{ color }}>
                            <i className={iconClass}></i>
                        </span>
                    );

                }
            },
        ],
        []
    );

    useEffect(() => {
        fetchCustomerWiseSalesReport({})
    }, [])

    const fetchCustomerWiseSalesReport = (data) => {
        getActualSaleVsTarget(data)
            .then((response) => {
                if (response.status && response.code == 200) {
                    setTargetData(response.data.data);
                    const { totalItems, totalPages, currentPage } = response.data
                    setPagination({
                        pageIndex: currentPage,
                        pageCount: totalPages,
                        totalRecords: totalItems,
                    })
                } else {
                    setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                    setTargetData([])
                }
            })
            .catch((err) => { console.log(err) })
    }

    const handlePageChange = (page, pageSize, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus, filter = filters) => {
        setPageSize(pageSize);
        setCurrentPage(page)
        fetchCustomerWiseSalesReport({ page, limit: pageSize, searchKey, columnName, sortingOrder, filters: filter })
    };

    const handleSortColumn = (option) => {
        setSortingOptions(option);
        const columnName = option.column;
        setColumnId(columnName);
        const sortingOrder = option.isAsc ? "asc" : "desc";
        setSortingOrderStatus(sortingOrder);
        handlePageChange(currentPage, pageSize, searchValue, columnName, sortingOrder);
    };

    const handleSearchFilter = (value, pageSize) => {
        const newValue = value !== undefined ? value : "";
        setSearchValue(newValue);
        handlePageChange(1, pageSize, newValue);
    };

    const handleClearSearch = () => {
        setSearchValue("");
        setFilters(null)
        if (flatpickrRef.current) {
            flatpickrRef.current.flatpickr.clear();
            flatpickrRef.current.flatpickr.close();
        }
        handlePageChange(1, pageSize, "", 'id', 'desc', null);
    };

    const handleDateFilter = () => {
        handlePageChange(1, pageSize, searchValue, columnId, sortingOrderStatus, filters)
    }

    const handleDateChange = (selectedDates) => {
        if (selectedDates.length === 2) {
            setFilters({
                startDate: selectedDates[0],
                endDate: selectedDates[1],
            })
        }
    };

    const downloadExcel = () => {
        let dataWithModifiedCol = targetData.map(report => {
            let newReport = {
                "Target": formatNumberWithCommas(report.targetSaleInLac),
                "Actual Sale": formatNumberWithCommas(report.actualSaleInLac),
                "Difference": formatNumberWithCommas(report.difference),
                "Month": formatDate(report.month),
            }
            return newReport
        })

        // Create a new workbook
        const workbook = XLSX.utils.book_new();
        const sheetData = XLSX.utils.json_to_sheet(dataWithModifiedCol);
        // Add the sheet to the workbook
        XLSX.utils.book_append_sheet(workbook, sheetData, 'Targets');
        // Save the workbook as an Excel file
        XLSX.writeFile(workbook, 'Targets.xlsx');
    };

    const customeFilterSection = (
        <div className="d-sm-flex align-items-center justify-content-start gap-2">
            <InputGroup style={{ minWidth: '250px' }} className="mb-2 mb-sm-0">
                <Flatpickr
                    ref={flatpickrRef}
                    className="form-control"
                    placeholder="Start Date - End Date"
                    options={{
                        mode: 'range',
                        dateFormat: 'd-m-Y',
                    }}
                    value={filters?.startDate && filters?.endDate ? [filters?.startDate, filters?.endDate] : []}
                    onChange={handleDateChange}
                />
                <Button variant="primary"
                    onClick={handleDateFilter}
                    style={{ backgroundColor: "#344fa0", border: "none" }}>
                    Go
                </Button>
            </InputGroup>
            <Button
                type="button"
                color="success"
                className="btn-rounded mb-2 mb-sm-0"
                onClick={handleClearSearch}
                outline
            >
                {'Clear'}
            </Button>
        </div>
    )

    const buttonSection = (
        <div className="text-sm-end">
            {targetData?.length > 0 && (<Button
                type="button"
                color="success"
                className="btn-rounded mb-2 me-2"
                onClick={downloadExcel}
            >
                <i className="bx bx-archive-in me-1" />
                {'Download'}
            </Button>)}

        </div>
    );

    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs title="Reports" breadcrumbItem="Target Vs Actual Sale List" />
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardBody>
                                <TableContainerV1
                                    columns={columns}
                                    data={targetData}
                                    pagination={pagination}
                                    handlePageChange={handlePageChange}
                                    searchHelperText="Search by Customer Name"
                                    handleSearchFilter={handleSearchFilter}
                                    customFilterSection={customeFilterSection}
                                    customSection={buttonSection}
                                    sortOptions={sortingOptions}
                                    handleClearSearch={handleClearSearch}
                                    handleSortColumn={handleSortColumn}
                                    className="custom-header-css"
                                    hideSearchView={true}
                                />
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default TargetVsActual;
const formatDate = (dateString) => {
    return moment(dateString, "YYYY-MM").format("MMMM, YYYY");
};